import { jsx as c } from "react/jsx-runtime";
import { a as F, u as M } from "./useAEMEditorComponentSize-4d8ec5ae.mjs";
import { BREAKPOINTS as W } from "@fcamna/shared-component-foundations";
import { fordProIcons as w } from "@fcamna/shared-icons";
import { createContext as x, useState as $, useRef as L, useMemo as S, useEffect as D, useContext as O } from "react";
import u from "styled-components";
import { u as Y } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { IconButton as j } from "./iconButton.js";
import { u as N } from "./useWindowDimensions-ae69e913.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./index-65016bfa.mjs";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./icon.js";
const R = (e = {}, n = {}) => Object.entries(e).every(([t, o]) => n[t] === o), h = (e, n = []) => n.reduce((t, o) => R(o.props, e) ? {
  ...t,
  ...o.styles || {},
  ...h(e, o.variants)
} : t, {}), { PlayFilled: A, Pause: U } = w, _ = "50%", q = "70%", G = u.div`
  ${({ width: e, ...n }) => {
  var t, o, r, i, a, s, l;
  return {
    width: e,
    ...((r = (o = (t = n.theme) == null ? void 0 : t.components) == null ? void 0 : o.landingHeroVideo) == null ? void 0 : r.Component.styles) || {},
    ...h(n, (l = (s = (a = (i = n.theme) == null ? void 0 : i.components) == null ? void 0 : a.landingHeroVideo) == null ? void 0 : s.Component) == null ? void 0 : l.variants)
  };
}}
`, K = u.div`
  ${(e) => {
  var n, t, o, r, i, a, s;
  return {
    ...((o = (t = (n = e.theme) == null ? void 0 : n.components) == null ? void 0 : t.landingHeroVideo) == null ? void 0 : o.HeadingContent.styles) || {},
    ...h(e, (s = (a = (i = (r = e.theme) == null ? void 0 : r.components) == null ? void 0 : i.landingHeroVideo) == null ? void 0 : a.HeadingContent) == null ? void 0 : s.variants)
  };
}}
`, Q = u.div`
  ${(e) => {
  var n, t, o;
  return {
    ...((o = (t = (n = e.theme) == null ? void 0 : n.components) == null ? void 0 : t.landingHeroVideo) == null ? void 0 : o.VideoWrapper.styles) || {}
  };
}}
`, J = u.div`
  ${(e) => {
  var n, t, o, r, i, a, s;
  return {
    ...((o = (t = (n = e.theme) == null ? void 0 : n.components) == null ? void 0 : t.landingHeroVideo) == null ? void 0 : o.VideoOverlayWrapper.styles) || {},
    ...h(e, (s = (a = (i = (r = e.theme) == null ? void 0 : r.components) == null ? void 0 : i.landingHeroVideo) == null ? void 0 : a.VideoOverlayWrapper) == null ? void 0 : s.variants)
  };
}}
`, X = u.div`
  ${(e) => {
  var n, t, o;
  return {
    ...((o = (t = (n = e.theme) == null ? void 0 : n.components) == null ? void 0 : t.landingHeroVideo) == null ? void 0 : o.VideoElementWrapper.styles) || {}
  };
}}
`, Z = u.h1`
  && {
    ${(e) => {
  var n, t, o;
  return (o = (t = (n = e.theme) == null ? void 0 : n.components) == null ? void 0 : t.landingHeroVideo) == null ? void 0 : o.VideoTitleWrapper.styles;
}}
  }
  ${(e) => {
  var o, r, i, a;
  const n = ((a = (i = (r = (o = e.theme) == null ? void 0 : o.components) == null ? void 0 : r.landingHeroVideo) == null ? void 0 : i.VideoTitleWrapper) == null ? void 0 : a.styles) || {}, t = n["& > sup"].fontSize;
  return `
          div {
            & > h1 {
              font-family: ${n == null ? void 0 : n.fontFamily};
              font-size: ${n == null ? void 0 : n.fontSize};
              letter-spacing: ${n == null ? void 0 : n.letterSpacing};
              font-weight: ${n == null ? void 0 : n.fontWeight};
              line-height: ${n == null ? void 0 : n.lineHeight};
              color: ${n == null ? void 0 : n.color};
              & > sup {
                font-size: ${t};
              }
            }
          }
        `;
}}
`, T = u.div`
  ${(e) => {
  var n, t, o, r, i, a, s;
  return {
    ...((o = (t = (n = e.theme) == null ? void 0 : n.components) == null ? void 0 : t.landingHeroVideo) == null ? void 0 : o.VideoPlaybackButtonWrapper.styles) || {},
    ...h(e, (s = (a = (i = (r = e.theme) == null ? void 0 : r.components) == null ? void 0 : i.landingHeroVideo) == null ? void 0 : a.VideoPlaybackButtonWrapper) == null ? void 0 : s.variants)
  };
}}
`;
function nn({ children: e, ...n }) {
  return /* @__PURE__ */ c(Q, { ...n, children: e });
}
function k({ children: e, ...n }) {
  const { contentAlignment: t } = O(C);
  return /* @__PURE__ */ c(
    K,
    {
      $contentAlignment: t,
      ...n,
      children: e
    }
  );
}
function en({ children: e, ...n }) {
  return /* @__PURE__ */ c(Z, { ...n, children: e });
}
function tn({
  children: e,
  onClick: n,
  size: t,
  buttonAlignment: o = "left",
  ...r
}) {
  const { isPlaying: i, playbackIcon: a, handleOnClick: s, playButtonSize: l } = O(C);
  function m(V) {
    s(), n == null || n(V, !i);
  }
  return /* @__PURE__ */ c(
    T,
    {
      ...r,
      $buttonAlignment: o,
      children: /* @__PURE__ */ c(
        j,
        {
          icon: a,
          onClick: m,
          size: t || l
        }
      )
    }
  );
}
function on({
  videoProps: e,
  onPlay: n,
  onPause: t,
  onEnded: o,
  loopAmount: r = 0,
  pauseTime: i = -1,
  ...a
}) {
  const { defaultVideoProps: s, loopCount: l, setLoopCountFunc: m } = O(C), { onPlay: V, onPause: H, loop: f, ref: p, ...P } = s, y = Math.floor(r);
  function I() {
    V(), n == null || n();
  }
  function b() {
    H(), t == null || t();
  }
  function E() {
    if (y > 0) {
      const g = p == null ? void 0 : p.current;
      l + 1 < y ? (m(l + 1), g.currentTime = 0, g.play()) : (i >= 0 && (g.currentTime = i), g.pause());
    }
    o == null || o();
  }
  return /* @__PURE__ */ c(
    X,
    {
      videoProps: e,
      ...a,
      children: /* @__PURE__ */ c(
        "video",
        {
          ...P,
          loop: y > 0 ? !1 : f,
          ...e,
          onPlay: I,
          onPause: b,
          onEnded: E,
          ref: p
        }
      )
    }
  );
}
function rn({
  playingOpacity: e = _,
  pausedOpacity: n = q,
  ...t
}) {
  const { isPlaying: o } = O(C);
  return /* @__PURE__ */ c(
    J,
    {
      $isPlaying: o,
      ...t
    }
  );
}
const C = x({
  defaultVideoProps: {
    loop: !0,
    ref: void 0,
    onPlay: () => {
    },
    onPause: () => {
    }
  },
  isPlaying: !1,
  playbackIcon: /* @__PURE__ */ c(A, {}),
  playButtonSize: "medium",
  handleOnClick: () => {
  },
  contentAlignment: "left",
  loopCount: 0,
  setLoopCountFunc: (e) => {
  }
});
function d({ children: e, contentAlignment: n = "left", ...t }) {
  const o = Y({ label: "Landing Hero Video" }), [r, i] = $("medium"), [a, s] = $(/* @__PURE__ */ c(A, {})), [l, m] = $(!1), [V, H] = $(0), f = L(null), p = "100%", P = L(null), y = S(() => F.AuthoringUtils.isInEditor(), []), [I] = M(P, y, p);
  function b() {
    s(/* @__PURE__ */ c(A, {})), m(!1);
  }
  function E() {
    s(/* @__PURE__ */ c(U, {})), m(!0);
  }
  function g() {
    const B = f == null ? void 0 : f.current;
    l ? B.pause() : (H(0), B.play());
  }
  const { width: z } = N();
  D(() => {
    z < W.laptopMin ? i("medium") : i("large");
  }, [z]);
  const v = {
    playsInline: !0,
    autoPlay: !0,
    muted: !0,
    loop: !0,
    onPlay: E,
    onPause: b,
    ref: f,
    role: "video"
  };
  return /* @__PURE__ */ c(
    G,
    {
      ref: P,
      width: I,
      $contentAlignment: n,
      ...t,
      ...o,
      children: /* @__PURE__ */ c(
        C.Provider,
        {
          value: {
            defaultVideoProps: v,
            isPlaying: l,
            handleOnClick: g,
            playbackIcon: a,
            playButtonSize: r,
            contentAlignment: n,
            loopCount: V,
            setLoopCountFunc: H
          },
          children: e
        }
      )
    }
  );
}
d.Content = k;
d.HeaderContainer = k;
d.VideoContainer = nn;
d.Title = en;
d.PlaybackButton = tn;
d.VideoElement = on;
d.Overlay = rn;
export {
  d as LandingHeroVideo
};
